<template>
<div id="dashboard">
<div v-if="!states.viewAllow && !states.showFail" class="loader overlay">
    <img class="overlay-container" src="@/assets/img/loader.gif" />
  </div>
  <div  v-if="states.showFail">
    <p></p>
      <div v-if="states.onServerError" class="text-center">
      <label>Došlo k neočakávanej chybe. Skúste neskôr.</label>
      </div>
      <div v-else>
      <p class="text-center" v-if="tplData.general"><label v-html="tpl('general.errorLoading')"></label></p>
      </div>
  </div>
  <div v-if="states.viewAllow && states.mainView && !appOff">
  <div class="row">
    <div class="large-12 medium-12 small-12 columns"><p></p>
        <h2 v-html="campaign.title"></h2>
        <hr/><p></p>
        <div v-html="campaign.main"></div>
        <a class="actions action" v-on:click = "callAction('start')" v-text="campaign.btn"></a>
        <div v-html="campaign.footer"></div>
    </div>   
  </div>   
  </div>
  <activations v-if="states.activationsView" :states="states" :productdetail="productdetail" :tplData="tplData" :pkgDef="pkgDef" :nextPacks="[]"></activations>

  <div v-if="appOff" id="dashboard">
    <div class="row">
        <div class="large-12 medium-12 small-12 columns text-center"><p></p>
            <p v-html="states.offText"></p>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import moment from 'moment'
import Activations from '@/components/balickyaction'
import pkgDef from '@/assets/js/pkgDef'


export default {
  name: 'Nekonecno',
  components: {
    Activations
  },
  data () {
    return {
      msg: 'Dvojnásobné dáta',
      seen: false,
      tplData: {},
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      states: {
        viewAllow: false, showFail: false, zoneText: '', activationsView: false, mainView: true, onServerError: false, offText: 'ODSTÁVKA'
      },
      routeToPkg: { "Nekonecno": "10D_UnLtd" },
      msisdn: '',
      productdetail: {},
      pkgDef: pkgDef.tkarta,
      moment: moment,
      namesMap: {"GIGA1W":"Raz Giga", "GIGA1M":"Vždy Giga", "GIGA2":"Vždy 2 Giga", "StreamOn Data Unlmtd":"Stream On", "StreamOn Data 200":"Stream On 200 MB", "GIGA6":"Dáta na rok 6GB", "GIGA24":"Dáta na rok 24GB", "GIGADEN":"Giga Deň",
      "SW Data":"Dáta pre blízkych", "Magenta Data":"Darované dáta z Magenta 1", "Promo Data":"Daruj a dostaneš", "GIGAZIMNY":"Giga akcia", "DATA500": "500 MB"},
      campaign: { title: '&nbsp;', main: '', footer: '', btn: 'AKTIVOVAŤ' }
    }
  },
  created: function() {
    var that = this

    if (document.getElementById("msisdnTextSpan") === null) {
      var msisdnTextSpan = document.createElement("span")
      msisdnTextSpan.id = "msisdnTextSpan"
      var msisdnTemp = document.getElementById("jsHolder")
      msisdnTemp.appendChild(msisdnTextSpan)
    }  else {
      var msisdnTextSpan = document.getElementById("msisdnTextSpan")
    }

    var productDetailAllow = false, tplDataAllow = false;

      this.$http.get(this.$store.state.productDetailSrc)
      .then(function (resp) {
          that.productdetail = resp.data
          that.msisdn = resp.data.msisdn
          msisdnTextSpan.innerHTML = '0' + that.msisdn.toString().substring(3)
          that.$store.commit('updateProductDetail', resp.data)
          that.$store.commit('httpProductDetail', resp.status)
          productDetailAllow = true
          if (tplDataAllow) {
            that.states.viewAllow = true
            that.setCmp()
          }          
      })
      .catch(function(e){
       if (e.response.status === 403) {
          window.location.href = '/prihlasenie/?url=' + encodeURIComponent(that.$router.history.base + that.$route.fullPath)
       } else if (e.response.status === 400) {
          window.location.href = '/'
       } else if (e.response.status === 502) {
          that.states.showFail = true
          that.states.onServerError = true
       } else {
          window.location.href = '/'
       }
    })
    this.$http.get(this.$store.state.tplSrc)
    .then(function (resp) {
      tplDataAllow = true
      that.tplData = resp.data
      that.$store.commit('updateTplData', resp.data)
      that.$store.commit('httpTplData', resp.status)
      if (productDetailAllow) {
        that.states.viewAllow = true
        that.setCmp()
      }
    }).catch(function(e){
      if (productDetailAllow) {
        that.states.viewAllow = true
        that.setCmp()
      } else {
          window.location.href = '/'
      }
    })
  },
  methods: {
    formatMsisdn: function(virgin) {
      return '0' + String(virgin).substring(3)
    },
    formatPrice: function (virgin, active) {
      return parseFloat(virgin).toFixed(2).toString().replace(/\./, ',') + " €"
    },
    setCmp: function() {
      var that = this, currType = {}
      if (((this.productdetail.product.productName).toLowerCase()).indexOf('t karta') !== -1) {
        _.forEach(that.pkgDef, function(m) {
          if (m.offerBName == that.routeToPkg[that.$route.name]) {
            m.singleType = 'tkarta';
            currType = m
          }  
        });
        currType.readable = that.tplData.package.name[currType.bucketName] || that.namesMap[currType.bucketName] || currType.bucketName
        that.states.currPkg = currType
        that.states.pkgAction = currType.bucketName
        that.campaign.main = that.tplData.offer.campaign[currType.bucketName].main
        that.campaign.btn = that.tplData.offer.campaign[currType.bucketName].btn
        that.campaign.footer = that.tplData.offer.campaign[currType.bucketName].footer
        that.campaign.title = that.tplData.offer.campaign[currType.bucketName].title
      } else {
        that.$router.replace('/zmena-programu')
      }
    },    
    callAction: function(pAction) {
      this.states.activationsView = true
      this.states.directAction = pAction
      this.states.isDirect = true
      this.$store.commit('setOverride', true)
    }
  },
  computed: {
    appOff: function() {
      if (this.tplData.general !== undefined) {
        if ((this.tplData.general.appOff === "true") && (!this.$route.query.override == "1")) {
          this.states.offText = this.tplData.general.offText
          return true
        } else {
          return false
        }
      }
    }
  }
}
</script>

<style scoped>
.mfet {
  color: #E20074;
 }
.pcg-sub {
  border: 1px solid #E20074;
  position: relative;
  margin-bottom: 2rem;
}

.sub-content {
  width: 100%;
  display: flex;
  padding: 10px;
}

.pcg-sub .sub-heading {
  width: 100%;
  line-height: 2.4rem;
  color: #ffffff;
  background-color: #E20074;
  padding: 0 10px;
  font-size: 1.2rem;
  font-weight: bold;
}

.sPkg {
  margin-bottom: 1rem;
  position: relative;
  background-color: #ededed;
  box-shadow: 0 -2px 2px 0 #c4c4c4 inset
}

.pcg_right {
  position: absolute;
  right: 10px;
  top: 1.6rem;
  font-size: 1.7rem;
}

.pcg-block-left {
  flex: 0 0 40px;
  position: relative;
}

.pcg-block-right {
  flex: 1;
}

.pkg_desc {
  padding: 0 10px 10px 40px;
}

.pkg_container {
  padding: 10px 10px 4px 10px;
}

.pcg-title {
  text-transform: uppercase;
}

</style>
